import React, { useState } from 'react';
import { Tabs } from '../ui';
import SessionsView from './LoginActivity/SessionsView';
import SignInsView from './LoginActivity/SignInsView';
import { loginActivityStyles as styles } from './LoginActivity/loginActivityStyles';

type View = 'sessions' | 'sign-ins';

const VIEW_OPTIONS: Array<{ value: View; label: string }> = [
  { value: 'sessions', label: 'Sessions' },
  { value: 'sign-ins', label: 'Sign-ins' },
];

const SUBTITLES: Record<View, string> = {
  sessions:
    'A session starts with the first activity after 30 idle minutes, or with a sign-in. Web rows list the dashboards opened; Claude rows list the Genius tools called through the connector.',
  'sign-ins': "Each row is a fresh sign-in. Silent token refreshes don't appear.",
};

const LoginActivityTab: React.FC = () => {
  const [view, setView] = useState<View>('sessions');

  return (
    <div style={styles.section}>
      <div style={styles.sectionHeader}>
        <div>
          <h2 style={styles.sectionTitle}>Login Activity</h2>
          <p style={styles.sectionSubtitle}>{SUBTITLES[view]}</p>
        </div>
        <Tabs<View> value={view} onChange={setView} options={VIEW_OPTIONS} size="sm" ariaLabel="Login activity view" />
      </div>

      {view === 'sessions' ? <SessionsView /> : <SignInsView />}
    </div>
  );
};

export default LoginActivityTab;
